<template>
  <client-only>
    <div id="address-wrapper">
      <input
        ref="autocomplete"
        type="text"
        item-text="NameInHebrew"
        id="AddressAutoComplete"
        :class="showRectangled ? 'rectangle-input' : ''"
        :placeholder="isText ? text : 'ישוב מגורים'"
      />
      <v-icon class="icon-pin" id="pin-icon"></v-icon>
    </div>
  </client-only>
</template>

<script>
export default {
  props: {
    showRectangled: {
      type: Boolean,
      required: false,
      default: false
    },

    isText: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      autocomplete: undefined,
      text: 'הזן כתובת מוצא'
    }
  },

  mounted() {
    this.usersAddress
  },
    updated() {
    this.$nextTick(() => {
      this.initAutocomplete()
    })
  },

  methods: {
    initAutocomplete() {
      // Create the autocomplete object, restricting the search to geographical
      // location types.

      var autoCompleteInput = this.$el.querySelector('#AddressAutoComplete')

      this.autocomplete = new google.maps.places.Autocomplete(
        autoCompleteInput,
        { types: ['geocode'] }
      )

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      this.autocomplete.addListener('place_changed', this.fillInAddress)
    },

    fillInAddress() {
      let place = this.autocomplete.getPlace()
      let lat = place.geometry.location.lat()
      let long = place.geometry.location.lng()
      let addressFormatted = place.formatted_address
      let placeObj = {}
      placeObj.lng = long
      placeObj.lat = lat
      placeObj.address = addressFormatted
      this.$emit('updateLocation', placeObj)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  position: relative;
  padding: 7px 0;
  border: solid 1px rgba(0, 0, 0, 0.24);
  padding-right: 50px;
  width: 100%;
  border-radius: 28px;
  background: #fff;
}

.testing-GLA {
  background: white;
}

#address-wrapper {
  position: relative;
}

#pin-icon {
  position: absolute;
  right: 15px;
  top: 7px;
}

.rectangle-input {
  border-radius: 0;
  max-width: 300px;
  max-height: 36px;
}
</style>
